import {
  MerchantSetupProductSchema,
  MerchantSetupProgressSchema,
} from "@redotech/redo-onboarding-db-schema";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const dismissMerchantSetupTask = {
  name: "dismissMerchantSetupTask" as const,
  input: z.object({
    product: MerchantSetupProductSchema,
    taskId: z.string().min(1).max(128),
  }),
  output: zExt.filterToValid(MerchantSetupProgressSchema),
};
